import Cookies from 'js-cookie';
import { apiFetch } from '../client';

let routeStartTime = null;
let currentRoute = null;

const mapEventData = (routeName, timeSpentMs, eventName = 'route_time_spent') => {
  return JSON.stringify({
      event_name: eventName,
      event_data: {
        route: routeName,
        time_spent_seconds: Math.round(timeSpentMs / 1000),
      }
  })
}

export function startRouteTracking(routeName) {
  if (routeStartTime && currentRoute) {
    endRouteTracking();
  }

  routeStartTime = performance.now();
  currentRoute = routeName;
}

export function endRouteTracking() {
  if (!routeStartTime || !currentRoute) return;

  const timeSpentMs = Math.round(performance.now() - routeStartTime);
  const eventData = mapEventData(currentRoute, timeSpentMs);
  
  
  routeStartTime = null;
  currentRoute = null;

  return apiFetch('/route-tracking-event/', {
    method: 'POST',
    body: eventData
  });
}

/**
 * Send data to backend via Beacon API. Used when user switches tab or closes page.
 * https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
 */
function sendBeacon(route, timeSpentMs) {
  const eventName = 'route_time_spent';
  const eventData = mapEventData(route, timeSpentMs, eventName);

  const formData = new FormData();
  formData.append('csrfmiddlewaretoken', Cookies.get('csrftoken'));
  formData.append('event_name', eventName);
  formData.append('route-tracking-event', eventData);
  formData.append('left_domain', true);

  navigator.sendBeacon('/route-tracking-event/', formData);
}

/**
 * Call on app init and then send tracking data once when tab becomes hidden 
 * (tab switch, minimize, close, or navigate away).
 */
export function initUnloadTracking() {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden' && routeStartTime && currentRoute) {
      const timeSpentMs = Math.round(performance.now() - routeStartTime);
      sendBeacon(currentRoute, timeSpentMs);
      routeStartTime = performance.now();
    }
  });
}